import Vendors from '@/sections/vendors/summary/vendors-summary-page';
import VendorSettings from '@/sections/vendors/settings/vendors-settings-page';
import VendorHistory from '@/sections/vendors/history/vendors-history';

export default [
	{
		name: 'vendors',
		path: '/vendors',
		props: route => ({
			search: route.query.search || '',
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc',
			status: route.params.status || 'active',
			count: parseInt(route.query.count)
		}),
		component: Vendors,
		meta: {
			permissions: ['vendors.read']
		}
	},
	{
		name: 'vendors-settings',
		path: '/vendors/:id/settings',
		props: route => ({
			id: route.params.id
		}),
		component: VendorSettings,
		meta: {
			permissions: ['vendors.update']
		}
	},
	{
		name: 'vendors-settings-by-code',
		path: '/vendors/edit/code/:integratorCode',
		props: route => ({
			integratorCode: route.params.integratorCode
		}),
		component: VendorSettings,
		meta: {
			permissions: ['vendors.update']
		}
	},
	{
		name: 'vendors-history',
		path: '/vendors/:changedEntityId/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search || '',
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			changedEntityId: route.params.changedEntityId,
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10
		}),
		component: VendorHistory,
		meta: {
			permissions: ['features.read']
		}
	}
];
